import { sendRequest } from "@/helpers";
//import { useUserStore } from "@/stores/userStore";
import { getUserLocale } from "@/i18n";

export default {
  async doRequest(link, method, data = "") {
    return await sendRequest(link, "post", data);
  },

  async getTopbarMenu() {
    let lang = getUserLocale();
    return await sendRequest(
      `/api/v1/admin_panel/menu?locale=${lang}`,
      "get",
      ""
    );
  },

  async getEntityFields(entity) {
    let lang = getUserLocale();

    //let ent = useUserStore().checkEnitty(entity);
    //if(ent){
    //  return ent;
    //} else {
    let res = await sendRequest(
      `/api/v1/admin_panel/schema/${entity}?locale=${lang}`,
      "get",
      ""
    );
    //useUserStore().addEntity(res, entity);
    return res;
    //}
  },

  async getEntityData(entity, instance) {
    return await sendRequest(
      `/api/v1/admin_panel/entity/${entity}/${instance}`,
      "get",
      ""
    );
  },

  async getEntityItems(entity, params = null) {
    return await sendRequest(
      `/api/v1/admin_panel/get_entities/${entity}?relationship_data=false`,
      "post",
      params
    );
  },

  async getEntityItemsLimit(entity, skip, limit, params = null, page = false) {
    return await sendRequest(
      `/api/v1/admin_panel/get_entities/${entity}?relationship_data=false&skip=${skip}&limit=${limit}&page_data=${page}`,
      "post",
      params
    );
  },

  async updateEntityItem(entity, data) {
    return await sendRequest(
      `/api/v1/admin_panel/entity/${entity}/${data?.id}`,
      "put",
      data
    );
  },

  async deleteEntityInstance(entity, id) {
    return await sendRequest(
      `/api/v1/admin_panel/entity/${entity}/${id}`,
      "delete",
      ""
    );
  },

  async createEntityItem(entity, data) {
    return await sendRequest(
      `/api/v1/admin_panel/entity/${entity}`,
      "post",
      data
    );
  },

  async getShelfPhoto(id_shelf) {
    return await sendRequest(`/api/current_shelf_image/${id_shelf}`, "get", "");
  },
  async sendShelvesZones(data) {
    return await sendRequest(`/api/update_shelf_sections`, "post", data);
  },
  async sendCustomRequest(url, method, data) {
    return await sendRequest(url, method.toLowerCase(), data);
  },
  async getDataRow(id, entity) {
    return await sendRequest(
      `/api/v1/admin_panel/entity?id=${id}&entity=${entity}`,
      "post",
      ""
    );
  },
  async getMonitoring(data = []) {
    return await sendRequest(
      "/api/dashboard/latest_conveniq_statuses",
      "post",
      data
    );
  },
  async getIndicators(data) {
    return await sendRequest(
      `/api/dashboard/conveniq_status_indicators?conveniq_id=${data}`,
      "get",
      null
    );
  },
  async executeRebootCommand(equipmentType, conveniqId) {
    return await sendRequest(
      `/api/v1/conveniq/reboot/${equipmentType}?conveniq_id=${conveniqId}`,
      "post",
      {}
    );
  },
  async executeConveniqCommand(conveniqId, commandId) {
    return await sendRequest(
      `/api/v1/conveniq/execute-command?conveniq_id=${conveniqId}&command_id=${commandId}`,
      "post",
      {}
    );
  },
  async UploadEntityCommand(entity_id, instance_id) {
    return await sendRequest(
      `/api/v1/conveniq/upload_entity_command?entity_id=${entity_id}&instance_id=${instance_id}`,
      "post",
      {}
    );
  },
};
